import React from "react";
import {
  Header,
  Grid,
  Modal,
  Form,
  Button,
  Input,
  TextArea,
  Image,
  Message,
} from "semantic-ui-react";
import menuBtnClose from "../../semantic/dist/themes/fibrestream/assets/images/close-modal.svg";
import { isEmail } from "../../util";
import axios from "axios";
import { Config } from "../../data/config";
import { displayError, resetError } from "../../store/actions/error";
import ErrorMessage from "../error-message/ErrorMessage";
import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import classNames from "classnames";

class MessageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      message: "",
      errors: {},
      isSent: false,
      isReCaptchaSelected: false,
    };
    this.onChange = this.onChange.bind(this);
    this.send = this.send.bind(this);
    this.onReCaptchaChange = this.onReCaptchaChange.bind(this);
    this.recaptchaRef = null;
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  componentDidMount() {
    this.props.resetError();
  }

  reset() {
    this.setState({
      first_name: "",
      last_name: "",
      email: "",
      message: "",
      errors: {},
      isReCaptchaSelected: false,
    });
    if (this.recaptchaRef) {
      this.recaptchaRef.reset();
    }
  }

  checkError() {
    const { first_name, last_name, email, message } = this.state;
    const errors = {};
    if (!first_name) {
      errors.first_name = "First name is required";
    }
    if (!last_name) {
      errors.last_name = "Last name is required";
    }
    if (!email) {
      errors.email = "Email is required";
    } else if (!isEmail(email)) {
      errors.email = "Invalid email";
    }
    if (!message) {
      errors.message = "Message is required";
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
      return true;
    }

    return false;
  }

  send() {
    this.setState({ errors: {}, isSent: false });
    if (this.checkError()) {
      return;
    }

    this.recaptchaRef.execute();
  }

  sendContactMessage() {
    const data = { ...this.state };
    delete data.errors;
    delete data.isSent;

    axios
      .post(`${Config.frontApiUrl}/contact/message`, data)
      .then((response) => {
        this.setState({ isSent: true });
        this.reset();
      })
      .catch((error) => {
        this.props.displayError();
      });
  }

  onReCaptchaChange(value) {
    if (value) {
      this.setState({ isReCaptchaSelected: true });
      this.sendContactMessage();
    } else {
      this.recaptchaRef.reset();
    }
  }

  render() {
    const { open, closeMessageModal } = this.props;
    const {
      first_name,
      last_name,
      email,
      message,
      errors,
      isSent,
    } = this.state;
    return (
      <Modal
        open={open}
        onClose={closeMessageModal}
        size="tiny"
        closeOnDimmerClick={false}
        closeOnEscape
        className="modal__message pos-relative"
      >
        <Modal.Content scrolling>
          <Form className="message__form input--grey">
            <Header as="h1" textAlign="center" className="message__title">
              Send us a message
            </Header>
            <Form.Group widths="equal" className="mb-0">
              <Form.Field
                className={classNames({ "is-error": errors.first_name })}
              >
                <Input
                  fluid
                  placeholder="First name"
                  labelPosition="right"
                  label={<div className="label__text">First name</div>}
                  name="first_name"
                  onChange={this.onChange}
                  value={first_name}
                />
                {errors.first_name && (
                  <div className="error-text">{errors.first_name}</div>
                )}
              </Form.Field>
              <Form.Field
                className={classNames({ "is-error": errors.last_name })}
              >
                <Input
                  fluid
                  placeholder="Last name"
                  labelPosition="right"
                  label={<div className="label__text">Last name</div>}
                  name="last_name"
                  onChange={this.onChange}
                  value={last_name}
                />
                {errors.last_name && (
                  <div className="error-text">{errors.last_name}</div>
                )}
              </Form.Field>
            </Form.Group>
            <Form.Field className={classNames({ "is-error": errors.email })}>
              <Input
                type="email"
                fluid
                placeholder="Email"
                labelPosition="right"
                label={<div className="label__text">Email</div>}
                name="email"
                onChange={this.onChange}
                value={email}
              />
              {errors.email && <div className="error-text">{errors.email}</div>}
            </Form.Field>
            <Form.Field className={classNames({ "is-error": errors.message })}>
              <TextArea
                placeholder="Message"
                rows="12"
                name="message"
                onChange={this.onChange}
                value={message}
              />
              {errors.message && (
                <div className="error-text">{errors.message}</div>
              )}
              <div className="label__text">Message</div>
            </Form.Field>
            <Grid className="section__recaptcha">
              <Grid.Column
                className="div1 d-flex"
                textAlign="left"
                computer={11}
                tablet={11}
                mobile={11}
              >
                <ReCAPTCHA
                  className="g-recaptcha"
                  size="invisible"
                  ref={(ref) => (this.recaptchaRef = ref)}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={this.onReCaptchaChange}
                />
                {errors.recaptcha && (
                  <Message error visible className="captcha-error">
                    <Header as="h5" textAlign="center">
                      {errors.recaptcha}
                    </Header>
                  </Message>
                )}
              </Grid.Column>
              <Grid.Column
                className="div2"
                textAlign="right"
                computer={5}
                tablet={5}
                mobile={5}
              >
                <Button
                  className="mt-24 medium form-button"
                  secondary
                  type="button"
                  onClick={this.send}
                >
                  Send
                </Button>
              </Grid.Column>
            </Grid>
            <Grid></Grid>
            <ErrorMessage />
            {isSent && (
              <Message success visible>
                <Header as="h5" textAlign="center">
                  Message sent successfully!
                </Header>
              </Message>
            )}
          </Form>
        </Modal.Content>
        <Button className="close-modal" onClick={closeMessageModal}>
          <span className="times text-prime">
            <Image src={menuBtnClose} verticalAlign="middle" />
          </span>
        </Button>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetError: () => dispatch(resetError()),
    displayError: () => dispatch(displayError()),
  };
};
export default connect(
  null,
  mapDispatchToProps
)(MessageModal);



// WEBPACK FOOTER //
// ./src/components/support/MessageModal.js